import {
  BasketMediumIcon,
  BillMediumIcon,
  CelebrationMediumIcon,
  HeartMediumIcon,
  HomeMediumIcon,
  MeterMediumIcon,
  SunMediumIcon,
} from '@utilitywarehouse/hearth-react-icons';

import { Category } from '@features/Cashback/Calculator/types';

export const categories: Category[] = [
  {
    id: 'cbcCalcGroceries',
    name: 'Groceries',
    icon: <BasketMediumIcon />,
    color: 'pig',
    max: 1500,
  },
  {
    id: 'cbcCalcTransportFuel',
    name: 'Transport & Fuel',
    icon: <MeterMediumIcon />,
    color: 'highlight',
    max: 600,
  },
  {
    id: 'cbcCalcFashionBeauty',
    name: 'Fashion & Beauty',
    icon: <HeartMediumIcon />,
    color: 'energy',
    max: 600,
  },
  {
    id: 'cbcCalcHomeGarden',
    name: 'Home & Garden',
    icon: <HomeMediumIcon />,
    color: 'mobile',
    max: 800,
  },
  {
    id: 'cbcCalcFoodDrink',
    name: 'Food & Drink',
    icon: <BillMediumIcon />,
    color: 'broadband',
    max: 600,
  },
  {
    id: 'cbcCalcEntertainmentTech',
    name: 'Entertainment & Tech',
    icon: <CelebrationMediumIcon />,
    color: 'insurance',
    max: 300,
  },
  {
    id: 'cbcCalcDaysOutGiftsHolidays',
    name: 'Days Out, Gifts & Holidays',
    icon: <SunMediumIcon />,
    color: 'cashback',
    max: 800,
  },
];
